// extracted by mini-css-extract-plugin
module.exports = {"Banner__wrapper":"RegisterSupplier_Banner__wrapper__2sMVK","Banner__title":"RegisterSupplier_Banner__title__3THQQ"};